import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SellComponent } from '../sell/sell.component';
import { BOSell } from '../../models/BOSell.model';
import { SellService } from '../../services/sell.service';
import { forkJoin, Subscription } from 'rxjs';
import { BOFilter } from '../../models/BOFilter';
import { PayTypeService } from '../../services/payType.service';
import { BOPayType } from '../../models/BOPayType.model';
import { BOInvoiceType } from '../../models/BOInvoiceType.model';
import { InvoiceTypeService } from '../../services/invoiceType.service';
import { BOClinicHistory } from '../../models/BOClinicHistory.model';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'invoicesModal',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit, OnDestroy
{
  @ViewChild('sellModal') public sellModal: SellComponent;

  busy: Subscription | undefined;
  sellFilter:string="";

  sellList:BOSell[]=[];
  sellListShort:BOSell[]=[];

  invoiceTypeList:BOInvoiceType[]=[];
  selectedArea=0;

  clinicHistoryList: BOClinicHistory[];
  clinicHistoryListShort: BOClinicHistory[];

  payTypeList:BOPayType[]=[];



  constructor(private _sellService: SellService,
              private _invoiceTypeService: InvoiceTypeService,
              private _payTypeService:PayTypeService,
              private _changeDetectorRef : ChangeDetectorRef,
              ) { }

  ngOnDestroy(): void {
  this.busy.unsubscribe();

  }

  ngOnInit(): void
  {
    console.log('Entra a ngOnInit');

    const filterInput:BOFilter={
      filter:this.sellFilter
    }

    this.busy = forkJoin({
      resultSells:this._sellService.getSells(filterInput),
      resultInvoiceType:this._invoiceTypeService.getAll(),
      resultPayType: this._payTypeService.getAll(),
    })
    .subscribe(({resultSells, resultInvoiceType, resultPayType})=>{
      this.sellList=resultSells;
      this.payTypeList=resultPayType;
      this.invoiceTypeList=resultInvoiceType;


      this.sellList.forEach(x=>{
        x.documentNumberInt=parseInt(x.documentNumber);
      })

      this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
      console.log(' this.sellList es:', this.sellList);

      this.sellListShort=this.sellList;
      //this.sellList.sort((a,b)=>{return new Date(b.dateSell).getTime() -new Date(a.dateSell).getTime()});

      this.sellList.forEach(x=>{
        x.payTypeSellDetails.forEach(pt=>{
          pt.payTypeName=this.payTypeList.find(z=>z.id==pt.payTypeId)?.name;
        })
      })

      this.sellList.forEach(x=>{
        x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
      })


      console.log('Sale de ngOnInit, this.sellListShort es:', this.sellListShort);

    })

  }

  ngOnInit2(): void
  {
    console.log('Entra a ngOnInit2');

    const filterInput:BOFilter={
      filter:this.sellFilter
    }

    this.busy = forkJoin({
      resultInvoiceType:this._invoiceTypeService.getAll(),
      resultPayType: this._payTypeService.getAll(),
    })
    .subscribe(({ resultInvoiceType, resultPayType})=>{
      this.payTypeList=resultPayType;
      this.invoiceTypeList=resultInvoiceType;
      console.log('Sale de ngOnInit2, this.sellListShort es:');

    })

  }

  getAllSells():void
  {
    console.log('Entra a getAllSells');

    this.sellList=[];
      this.sellListShort=[];

      const filterInput: BOFilter = {
          filter: this.sellFilter.toUpperCase().trim()
      };

      this.busy = this._sellService.getSells(filterInput)
      .subscribe(data=>{this.sellList = data;
          this.sellList.forEach(x=>{
            x.documentNumberInt=parseInt(x.documentNumber);
            x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
          })

        //  this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
          console.log(' this.sellList es:', this.sellList);
          this.sellListShort=this.sellList;

      });
      console.log('Sale de getAllSells, this.sellListShort es:', this.sellListShort);
  }

  getAllSellsByUserId(userId:number):void
  {
    console.log('Entra a getAllSellsByUserId');

    this.sellList=[];
      this.sellListShort=[];

      const filterInput: BOFilter = {
          filter: this.sellFilter.toUpperCase().trim()
      };

      this.busy = this._sellService.getAllSellsByUserId(userId)
      .subscribe(data=>{this.sellList = data;
          this.sellList.forEach(x=>{
            x.documentNumberInt=parseInt(x.documentNumber);
            x.invoiceTypeName=this.invoiceTypeList.find(z=>z.id==x.invoiceTypeId)?.name;
            x.payTypeSellDetails.forEach(pt=>{
              pt.payTypeName=this.payTypeList.find(z=>z.id==pt.payTypeId)?.name;
            })
          })

          this.sellList.sort((a, b) => (b.documentNumberInt ?? 0) - (a.documentNumberInt ?? 0));
          console.log(' this.sellList es:', this.sellList);
          this.sellListShort=this.sellList;

      });
      console.log('Sale de getAllSells, this.sellListShort es:', this.sellListShort);

      //console.log('En getAllSells sellList es:', this.sellList);

  }

  openUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    } else {
      console.error('URL inválida o no especificada.');
    }
  }

  onAreaSelectionChange(event: MatSelectChange): void
  {
    const selectedValue = event.value;
    this.selectedArea=selectedValue;

    this.sellListShort=[];

    if(this.selectedArea==3)
    {
     this.sellListShort=[...this.sellList];
    }
    else
    {
    let sellListFiltered=this.sellList.filter(x=>x.areaId==this.selectedArea);
    this.sellListShort=[...sellListFiltered];
    this._changeDetectorRef.detectChanges();
    }
  }

}
